/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, InfoLabel } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'

import { HistoricoVacinacaoDwModel } from './HistoricoVacinacaoDw'

export default function HistoricoVacinacaoDwTableItem(historico: HistoricoVacinacaoDwModel) {
  const imunoEstrategiaDose = `${historico.dimensaoImunobiologico.nome}, ${
    historico.dimensaoEstrategiaVacinacao?.nome ? `${historico.dimensaoEstrategiaVacinacao?.nome.capitalize()}, ` : ''
  }${historico.dimensaoDoseImunobiologico.nome.capitalize()}`

  const loteFab =
    !historico.nomeLote && !historico.nomeFabricante
      ? '-'
      : `${historico.nomeLote ?? '-'}/${historico.nomeFabricante?.titleCase() ?? '-'}`

  const dataAplicacao = formatDate(historico.dataRegistroVacinaAplicada)

  const cid10MotivoIndicacao = historico.dimensaoCid10MotivoIndicacao
  const cboPrescritor = historico.dimensaoCboPrescritor
  const viaAdministracao = historico.dimensaoViaAdministracao
  const localAplicacao = historico.dimensaoLocalAplicacao

  return (
    <Grid
      style={css`
        padding: 0.5rem 0;
      `}
    >
      <Cell size={5}>
        <InfoLabel title='Imunobiológico/Estratégia/Dose'>{imunoEstrategiaDose}</InfoLabel>
      </Cell>
      <Cell size={4}>
        <InfoLabel
          title='Lote/Fabricante'
          childStyles={css`
            overflow-wrap: break-word;
          `}
        >
          {loteFab}
        </InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Data de aplicação'>{dataAplicacao}</InfoLabel>
      </Cell>
      {viaAdministracao && (
        <Cell size={5}>
          <InfoLabel title='Via de administração'>{viaAdministracao.nome.capitalize()}</InfoLabel>
        </Cell>
      )}
      {localAplicacao && (
        <Cell size={4}>
          <InfoLabel title='Local de aplicação'>{localAplicacao.nome.capitalize()}</InfoLabel>
        </Cell>
      )}

      {cid10MotivoIndicacao && (
        <Cell size={5}>
          <InfoLabel title='Motivo de indicação'>
            {cid10MotivoIndicacao.nomeCid10.capitalize()} - {cid10MotivoIndicacao.codigoCid10}
          </InfoLabel>
        </Cell>
      )}
      {cboPrescritor && (
        <Cell size={7}>
          <InfoLabel title='Especialidade do profissional prescritor'>{cboPrescritor.cbo}</InfoLabel>
        </Cell>
      )}

      <Cell size={12}>
        <InfoLabel title='Pesquisa'>{historico.isPesquisaClinica ? 'Sim' : 'Não'}</InfoLabel>
      </Cell>
      {historico.isPesquisaClinica && (
        <Fragment>
          <Cell size={4}>
            <HLabel title='Anvisa protocolo estudo:'>{historico.anvisaProtocoloEstudo}</HLabel>
          </Cell>
          <Cell size={4}>
            <HLabel title='Anvisa protocolo versão:'>{historico.anvisaProtocoloVersao}</HLabel>
          </Cell>
          <Cell size={4}>
            <HLabel title='Anvisa número registro:'>{historico.anvisaNumeroRegistro}</HLabel>
          </Cell>
        </Fragment>
      )}
    </Grid>
  )
}
